import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

/* eslint react/jsx-filename-extension: 0 */
ReactDOM.render(<App />, document.getElementById('root'));
